import {Option} from './option';
import {ActivatedRouteSnapshot} from '@angular/router';
import {BehaviorSubject} from 'rxjs';

/**
 * @deprecated Use RouteOptions from the new pattern instead
 */
export abstract class GarfieldOptionsBundle {
	// Abstract ctors are weird in TS
	// https://www.typescriptlang.org/docs/handbook/2/classes.html#abstract-construct-signatures
	// Array of concrete ReportOption ctors to be provided by the concrete Report implementation
	protected abstract readonly _optionRefs: Array<new(...args: any[]) => Option>;

	// This uses a getter pattern with a backing variable because overridden properties are not available in the base ctor
	private _options?: Array<Option>;

	// Constructed ReportOptions
	abstract get options(): Array<Option>;

	protected constructor(
		public readonly route: ActivatedRouteSnapshot,
	) {}

	// Map to track state of route options to apply
	_applyRouteOptions = new Map<string, unknown>();
	// Observable allows us to see the application to routerLink in realtime with async pipe
	applyRouteOptions = new BehaviorSubject(this._applyRouteOptions);

	// use function to set initial values in param map (needed any place filter values are used)
	setInitialRouteValue = () => {
		// Initially populate with non-default values to preserve existing applied values
		this._applyRouteOptions = new Map(
			this.options.filter(option => !option.isDefaultValue())
				.map(option => ([option.routeParameterKey, option.appliedValue]))
		);
		this.applyRouteOptions.next(this._applyRouteOptions);
		// console.debug('initial optional route params', this._applyRouteOptions);
	}

	// use function to set route value w/ optional route params
	setRouteValue = (key: string, value: unknown) => {
		// console.debug('setRouteValue', key, value);
		const option = this.options.find(x => x.routeParameterKey === key);
		if (!option) {
			throw new Error(`ReportOption with routeParameterKey='${key}' not found.`);
		}
		if (!option.isDefaultValue(value)) {
			this._applyRouteOptions.set(key, value);
		} else {
			this._applyRouteOptions.delete(key);
		}
		this.applyRouteOptions.next(this._applyRouteOptions);
		// console.debug('this._applyRouteOptions', this._applyRouteOptions);
	}
}
